const maxFileSize = max => (value) => {

  const { size } = value;
  const sizeInBytes = size / 1024;
  return sizeInBytes < max;
};

export default maxFileSize;
